import { monthsGenitive } from "@/shared/consts/month-names"
import { format, getMonth } from "date-fns"

export const toLocaleDateTimeString = (date: string | Date): string => {
    if (typeof date === 'string') {
        const parsed = new Date(date)
        return `${format(parsed, 'dd')} ${monthsGenitive[getMonth(parsed)]} ${format(parsed, 'yyyy')} в ${format(parsed, 'HH:mm:ss')}`
    }
    return `${format(date, 'dd')} ${monthsGenitive[getMonth(date)]} ${format(date, 'yyyy')} в ${format(date, 'HH:mm:ss')}`
}

export const toLocaleDateString = (date: string | Date): string => {
    if (typeof date === 'string') {
        const parsed = new Date(date)
        return `${format(parsed, 'dd')} ${monthsGenitive[getMonth(parsed)]} ${format(parsed, 'yyyy')}`
    }
    return `${format(date, 'dd')} ${monthsGenitive[getMonth(date)]} ${format(date, 'yyyy')}`
}